export default __webpack_public_path__ + "static/media/kabir.2eb5ec4b.png";